import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDateRangePicker } from '@angular/material/datepicker';

@Component({
    selector: 'app-date-range-picker',
    templateUrl: './date-range-picker.component.html',
    styleUrls: ['../home/home.component.css'],
    standalone: false
})
export class DateRangePickerComponent {
  @Input()
  dateRangeForm!: FormGroup;
  @Output() dateChange = new EventEmitter<void>();
  @Output() dateClear = new EventEmitter<void>();
  @ViewChild('picker') picker!: MatDateRangePicker<Date>;

  handleDateChange() {
    this.dateChange.emit();
  }

  clearDates() {
    this.dateRangeForm.setValue({ start: null, end: null });
    this.picker.close();
    this.dateClear.emit();
  }
}
